// import logger from '@/logger/index'
const SITE_KEY = '6LfxZF4kAAAAAD9lJib9WrT6r_rEySpFF8bXalo8'

const getRecaptchaToken = async function () {
  const token = await new Promise((resolve, reject) => {
    if (!window.grecaptcha) {
      return reject(new Error('reCAPTCHA não carregado na página'))
    }

    window.grecaptcha
      .execute(SITE_KEY, { action: 'searchProducts' })
      .then(resolve)
      .catch(reject)
  })
  // logger.info('token: ', token)
  return token
}

export default {
  getRecaptchaToken,
}
